import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router"
import useTitle from "@/hooks/useTitle"

import EtEtTrinityIcon6SVGComp from "@/assets/img/icons/svgComp/EtEtTrinityIcon6SVGComp";
// 08 Mar 2025
import EtPerformIconSVGComp from "@/assets/img/icons/svgComp/EtPerformIcon2SVGComp";
import EtPrepareIconSVGComp from "@/assets/img/icons/svgComp/EtPrepareIcon1SVGComp";
import EtPlanIconSVGComp from "@/assets/img/icons/svgComp/EtPlanIcon1SVGComp";

// 14 Mar 2025
import { useFetchGoogleCalendarEventsQuery, useLazyFetchGoogleCalendarEventsQuery } from "@/features/calendarEvents/calendarEventsApiSlice";

// 19 Mar 2025 - Switching to getting data from the persisted UserCalendarEvent DB
import { useGetUserCalendarEventsQuery } from "@/features/calendarEvents/calendarEventsApiSlice";

// 21 Mar 2025 - for UserMeetingPrep
import { useGetUserMeetingPrepsQuery } from "@/features/userMeetingPreps/userMeetingPrepsApiSlice";

// 23 Mar 2025 - for displaying conversations
import { useGetUserConversationsQuery } from '@/features/userConversations/userConversationsApiSlice'

// 03 Apr 2025
import { useGetUserActionsQuery } from '@/features/userActions/userActionsApiSlice'

// 05 Apr 2025
import { useGetTrailsQuery } from '@/features/trails/trailsApiSlice'

// 08 Apr 2025
import { useGetUserCreationsQuery } from '@/features/userCreations/userCreationsApiSlice'
import { useGetUserGratitudesQuery } from '@/features/userGratitudes/userGratitudesApiSlice'
import { useGetUserContributionsQuery } from '@/features/userContributions/userContributionsApiSlice'
import { useGetUserImpactsQuery } from '@/features/userImpacts/userImpactsApiSlice'
import { useGetUserWinsQuery } from '@/features/userWins/userWinsApiSlice'
import { useGetUserIntentionsQuery } from '@/features/userIntentions/userIntentionsApiSlice'
import { useGetUserChallengeWABsQuery } from '@/features/userChallengeWABs/userChallengeWABsApiSlice'

// 12 Jun 2025
import { useGetContactsQuery } from "@/pages/admin/contacts/contactsApiSlice"

// 21 Mar 2025 - Modal
import EtModalUpdateUserMeetingPrep from '@/components/common/modal/EtModalUpdateUserMeetingPrep'
// 23 Mar 2025
import EtModalTrinityUserMeetingConversation from '@/components/common/modal/EtModalTrinityUserMeetingConversation'
// 04 Apr 2025
import EtModalUpdateUserAction from '@/components/common/modal/EtModalUpdateUserAction'
// 05 Apr 2025
import EtModalCreateUserActionLanding from '@/components/common/modal/EtModalCreateUserActionLanding';

//08 Apr 2025
import EtModalCreateUserImprintCreation from "@/components/common/modal/EtModalCreateUserImprintCreation"
import EtModalCreateUserImprintGratitude from "@/components/common/modal/EtModalCreateUserImprintGratitude"
import EtModalCreateUserContributionLanding from '@/components/common/modal/EtModalCreateUserContributionLanding';
import EtModalCreateUserImpactLanding from '@/components/common/modal/EtModalCreateUserImpactLanding';
import EtModalCreateUserWinLanding from '@/components/common/modal/EtModalCreateUserWinLanding';
import EtModalCreateUserIntentionLanding from '@/components/common/modal/EtModalCreateUserIntentionLanding';
import EtModalCreateUserChallengeWABLanding from '@/components/common/modal/EtModalCreateUserChallengeWABLanding';

// 09 Apr 2025
import EtModalCreateUserConversationLanding from '@/components/common/modal/EtModalCreateUserConversationLanding';

// 20 Mar 2025 - User Pic
import { useGetUserPicQuery } from "@/features/users/usersApiSlice"

// 14 Mar 2025
import moment from "moment";

// 19 Mar 2025
import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon 
} from "@heroicons/react/24/solid"

import {
  PlusIcon,
  MinusIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline"

// 20 Mar 2025
import { userProfileIcon2 } from "@/assets/img/imgAssets"

// 21 Mar 2025
import PulseLoader from "react-spinners/PulseLoader"
import { getTimeSince } from "@/utils/EtGetTimeSince"

// 21 Mar 2025
import EtMeetingIcon1SVGComp from '@/assets/img/icons/svgComp/EtMeetingPrepIcon1SVGComp'
import EtMeetingIcon2SVGComp from '@/assets/img/icons/svgComp/EtMeetingIcon1SVGComp'

// 22 Mar 2025
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp" 
import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp" 

// 08 Apr 2025
import EtWabCreationIcon1SVGComp  from "@/assets/img/icons/svgComp/EtWabCreationIcon1SVGComp" 
import EtWabGratitudeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabGratitudeIcon1SVGComp"  
import EtWabContributionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabContributionIcon1SVGComp"
import EtWabImpactIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabImpactIcon1SVGComp"
import EtWabWinIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabWinIcon1SVGComp"
import EtWabIntentionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabIntentionIcon1SVGComp"
import EtWabChallengeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabChallengeIcon1SVGComp"


// 03 Apr 2025
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'

// 12 Jun 2025
import EtMeetingCard from "@/components/meetings/EtMeetingCard";


const EtTrinityWebLandingAction = ({username, userId, userOrgId}) => {

  // Author - Atul Pandey
  // First Created - 07 Mar 2025
  // Purpose to act as the home page for Trinity Landing
  // Updated - 14 Mar 2025 - added username prop to the component and to pass it to other components called from here - i.e. Perform
  // Updated - 19 Mar 2025 - refinements for getting data from the persisted UserCalendarEvent DB
  // Updated - 21 Mar 2025 - refinements for getting data from the UserMeetingPrep DB
  // Updated - 24 Mar 2025 - refinements for fetch only upon user click and not on page load
  // Updated - 30 Mar 2025 - refinements for fetch only from the persisted DB and not triggering sync iCal
  // Updated - 31 Mar 2025 - refinements for data for Prepare and Plan if today is the last day of the month
  // Updated - 03 Apr 2025 - refinements for adding sub tabs for each area - i.e. Meetings , Actions 
  // Updated - 03 Apr 2025 - Added actions query to fetch user actions 
  // Updated - 04 Apr 2025 - Added refetch actions and the edit user action modal
  // Updated - 05 Apr 2025 - Added section for filtering actions by trails
  // Updated - 08 Apr 2025 - Added section for creating new user actions - moved from Perform section
  // Updated - 08 Apr 2025 - Added section for creating new user creation
  // Updated - 08 Apr 2025 - Added section for creating new user gratitude
  // Updated - 08 Apr 2025 - Added section for creating new user contribution
  // Updated - 08 Apr 2025 - Added section for creating new user impact
  // Updated - 08 Apr 2025 - Added section for creating new user win
  // Updated - 08 Apr 2025 - Added section for creating new user intention
  // Updated - 08 Apr 2025 - Added section for creating new user challenge
  // Updated - 09 Apr 2025 - Added section for creating new user conversations (without calendar meeting)
  // Updated - 20 May 2025 - Converted the Meeting Card component as an exportable component
  // Updated - 12 Jun 2025 - Switched from MeetinngCard to EtMeetingCard
  
  
  // 0 - Validate incoming data
  // console.log('username', username)
  // console.log('userId in web landing Action', userId)
  // console.log('userOrgId in web landing Action', userOrgId)

  // 1a - Set Page Title
  useTitle('Trinity Home - Actions')
  
  // 1b1 - State variables to show / hide sections
  const [ activeTab, setActiveTab ] = useState("perform") // 08 Mar 2025
  const [syncMessage, setSyncMessage] = useState(null); // 19 Mar 2025 - for showing sync message 
  const [fadeOut, setFadeOut] = useState(false) // 21 Mar 2025 - for fading out syncMsg
  const [activePerformSubTab, setActivePerformSubTab] = useState("meetings");   // 03 Apr 2025
  const [activePrepareSubTab, setActivePrepareSubTab] = useState("meetings");   // 03 Apr 2025
  const [activePlanSubTab, setActivePlanSubTab] = useState("meetings");         // 03 Apr 2025
  const [showCreateActionModal, setShowCreateActionModal] = useState(false) // 08 Apr 2025 - Original - 05 Apr 2025 (Perform Section)
  const [showCreateCreationModal, setShowCreateCreationModal] = useState(false) // 08 Apr 2025
  const [showCreateGratitudeModal, setShowCreateGratitudeModal] = useState(false) // 08 Apr 2025
  const [showCreateContributionModal, setShowCreateContributionModal] = useState(false) // 08 Apr 2025
  const [showCreateImpactModal, setShowCreateImpactModal] = useState(false) // 08 Apr 2025
  const [showCreateWinModal, setShowCreateWinModal] = useState(false) // 08 Apr 2025
  const [showCreateIntentionModal, setShowCreateIntentionModal] = useState(false) // 08 Apr 2025
  const [showCreateChallengeWABModal, setShowCreateChallengeWABModal] = useState(false) // 08 Apr 2025
  const [showCreateConversationModal, setShowCreateConversationModal] = useState(false) // 09 Apr 2025

  // 1b - Add New Items List
  const addNewItems = [
    { label: "Action", icon: EtWabActionIcon1SVGComp, onClick: () => setShowCreateActionModal(true) },
    { label: "Conversation", icon: EtWabConversationIcon1SVGComp, onClick: () => setShowCreateConversationModal(true) },
    { label: "Creation", icon: EtWabCreationIcon1SVGComp, onClick: () => setShowCreateCreationModal(true) },
    { label: "Gratitude", icon: EtWabGratitudeIcon1SVGComp, onClick: () => setShowCreateGratitudeModal(true) },
    { label: "Contribution", icon: EtWabContributionIcon1SVGComp, onClick: () => setShowCreateContributionModal(true) },
    { label: "Impact", icon: EtWabImpactIcon1SVGComp, onClick: () => setShowCreateImpactModal(true) },
    { label: "Win", icon: EtWabWinIcon1SVGComp, onClick: () => setShowCreateWinModal(true) },
    { label: "Challenge", icon: EtWabChallengeIcon1SVGComp, onClick: () => setShowCreateChallengeWABModal(true) },
    { label: "Intention", icon: EtWabIntentionIcon1SVGComp, onClick: () => setShowCreateIntentionModal(true) },
  ]

  // 2a1 - Fetch Calendar Data - 19 Mar 2025  Updated - 30 Mar 2025
  const { data:userCalendarEventsData, isLoading: isSyncing, error, refetch } = useGetUserCalendarEventsQuery(); 
  // const { data: userActionsData} = useGetUserActionsQuery() // 03 Apr 2025
  const { data: userActionsData, refetch: refetchUserActions } = useGetUserActionsQuery() // 04 Apr 2025
  const { data: trailsData } = useGetTrailsQuery() // 05 Apr 2025
  const { data: userCreationsData, refetch: refetchUserCreations } = useGetUserCreationsQuery() // 08 Apr 2025
  const { data: userGratitudesData, refetch: refetchUserGratitudes } = useGetUserGratitudesQuery() // 08 Apr 2025
  const { data: userContributionsData, refetch: refetchUserContributions } = useGetUserContributionsQuery() // 08 Apr 2025
  const { data: userImpactsData, refetch: refetchUserImpacts } = useGetUserImpactsQuery() // 08 Apr 2025
  const { data: userWinsData, refetch: refetchUserWins } = useGetUserWinsQuery() // 08 Apr 2025
  const { data: userIntentionsData, refetch: refetchUserIntentions } = useGetUserIntentionsQuery() // 08 Apr 2025
  const { data: userChallengeWABsData, refetch: refetchUserChallengeWABs } = useGetUserChallengeWABsQuery() // 08 Apr 2025

  const { data: contactsData } = useGetContactsQuery();// 12 Jun 2025

  
  // console.log('calendarData', userCalendarEventsData)
  // console.log('calendarData excluding all day', userCalendarEventsData?.filter(event => !event.isAllDay))

  // 2a2 - Fetch User Meeting Prep Data - 21 Mar 2025
  const { data: userMeetingPrepsData, isLoading: isLoadingMeetingPreps } = useGetUserMeetingPrepsQuery();
  
  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  const userMeetingPrepsAll = extractEntitiesFromAdapter(userMeetingPrepsData);
  const userActions = extractEntitiesFromAdapter(userActionsData)?.filter(item => item?.userId?.username === username); // 04 Apr 2025
  const trails = extractEntitiesFromAdapter(trailsData) // 05 Apr 2025
  const userCreations = extractEntitiesFromAdapter(userCreationsData)?.filter(item => item?.userId?.username === username) // 08 Apr 2025
  const userGratitudes = extractEntitiesFromAdapter(userGratitudesData)?.filter(item => item?.userId?.username === username) // 08 Apr 2025
  const userContributions = extractEntitiesFromAdapter(userContributionsData)?.filter(item => item?.userId?.username === username) // 08 Apr 2025
  const userImpacts = extractEntitiesFromAdapter(userImpactsData)?.filter(item => item?.userId?.username === username) // 08 Apr 2025
  const userWins = extractEntitiesFromAdapter(userWinsData)?.filter(item => item?.userId?.username === username) // 08 Apr 2025
  const userIntentions = extractEntitiesFromAdapter(userIntentionsData)?.filter(item => item?.userId?.username === username) // 08 Apr 2025
  const userChallengeWABs = extractEntitiesFromAdapter(userChallengeWABsData)?.filter(item => item?.userId?.username === username) // 08 Apr 2025

  const relevantContacts = extractEntitiesFromAdapter(contactsData) // 12 Jun 2025

  
  const userMeetingPreps = userMeetingPrepsAll?.filter(item => !item?.calendarMeetingId?.isAllDay)
  // console.log('meeting prep data', userMeetingPrepsData)
  // console.log('meeting preps', userMeetingPreps)
  //  console.log('userActions', userActions)
  // console.log('trails', trails)
  // console.log('user Creations', userCreations)
  // console.log('user Gratitudes', userGratitudes)
  // console.log('user Contributions', userContributions)
  // console.log('user Impacts', userImpacts)
  // console.log('user Wins', userWins)
  // console.log('user Intentions', userIntentions)
  // console.log('user ChallengeWABs', userChallengeWABs)

  // 2b1 - Today's calendar events
  const meetingsToday = userCalendarEventsData?.filter(event => 
    moment(event.startTime).isSame(moment(), 'day') && !event.isAllDay 
  ) || [];

  // 2b2 - Today's meeting preps
  const meetingPrepsToday = userMeetingPreps?.filter(event => 
    moment(event?.calendarMeetingId?.startTime).isSame(moment(), 'day')
  ) || [];

  // 2b3 - ✅ Actions due today or earlier - 03 Apr 2025
  const actionsToday = userActions?.filter(action => 
    moment(action.completeBy).isSameOrBefore(moment(), 'day') && action?.userActionProgress < 100
  ) || [];
 
  // 2c - Determine if today is the last day of the month - 31 Mar 2025
  const isEndOfMonth = moment().isSame(moment().endOf('month'), 'day')
  
  // 2c1 - This month's remaining events (From tomorrow until end of the month) - 31 Mar 2025
  const prepareStart = isEndOfMonth ? moment().startOf('month').add(1, 'month') : moment().endOf('day')
  const prepareEnd = isEndOfMonth ? moment().endOf('month').add(1, 'month') : moment().endOf('month')

  const meetingsThisMonth = userCalendarEventsData?.filter(event => 
    moment(event.startTime).isAfter(prepareStart) && 
    moment(event.startTime).isBefore(prepareEnd) &&
    !event.isAllDay
  ) || []

  // 2c2 - This month's remaining meeting preps (From tomorrow until end of the month) - updated 31 Mar 2025
  const meetingPrepsThisMonth = userMeetingPreps?.filter(event => 
    moment(event?.calendarMeetingId?.startTime).isAfter(prepareStart) && 
    moment(event?.calendarMeetingId?.startTime).isBefore(prepareEnd)
  ) || []

  // 2c3 - ✅ Actions due in Prepare range - 03 Apr 2025
  const actionsThisMonth = userActions?.filter(action => 
    moment(action.completeBy).isAfter(prepareStart) && 
    moment(action.completeBy).isBefore(prepareEnd)
  ) || [];
  
  // 2d1 - Plan: Events from the month after next if today is end of month - 31 Mar 2025
  const planStart = isEndOfMonth 
  ? moment().startOf('month').add(2, 'month') 
  : moment().startOf('month').add(1, 'month')

  const futureMeetings = userCalendarEventsData?.filter(event => 
  moment(event.startTime).isSameOrAfter(planStart) && !event.isAllDay
  ) || []

  // 2d2 - Future meeting preps beyond this month (Starting next month) - Updated 31 Mar 2025
  const futureMeetingPreps = userMeetingPreps?.filter(event => 
    moment(event?.calendarMeetingId?.startTime).isSameOrAfter(planStart)
  ) || []

  // 2d3 - ✅ Actions due in Plan range - 03 Apr 2025
  const actionsFuture = userActions?.filter(action => 
    moment(action.completeBy).isSameOrAfter(planStart)
  ) || [];

  useEffect(() => {
    if (syncMessage) {
      setFadeOut(false) // Reset fade on new message
      const timer1 = setTimeout(() => setFadeOut(true), 1500)  // Start fade after 1.5s
      const timer2 = setTimeout(() => setSyncMessage(null), 2000) // Remove message after 2s
      return () => {
        clearTimeout(timer1)
        clearTimeout(timer2)
      }
    }
  }, [syncMessage])

  return (
    <div>
     
      {isSyncing ? (
        <div className='bg-orange-600 p-2 flex justify-start items-center w-48 rounded'>
          <p className='text-white mx-1 px-1'>Syncing</p>
          <PulseLoader color={"#fff"} />
        </div>
      ):(   
        <div className='flex justify-between items-center m-1 p-1 font-poppins'>      
          <div 
              className="" 
              // 30 Mar 2025
              onClick={async () => {
                setSyncMessage(null);
                const result = await refetch(); // ✅ Just re-fetch DB-persisted data
            
                if (!result.error) {
                  setSyncMessage({ type: "success", text: "Calendar refreshed from DB." });
                } else {
                  setSyncMessage({ type: "error", text: "Failed to refresh calendar from DB." });
                }
              }}
            >
                <div className="h-7 w-7 flex justify-center items-center rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md">
                  <ArrowPathIcon className="h-5 w-5 text-white" />
                </div>
                <div >
                    <p className="text-[10px]">Refresh</p>
                </div>
          </div>

          <div className='flex justify-start items-center'>
            {/* RH Add Section Header */}
            <div className='mb-1 pb-1'>
              <p className='mx-1 px-1 font-bold'>Add a New : </p>
            </div> 
            {/* Add a New Action */}
            {addNewItems.map(({ label, icon: IconComp, onClick }) => (
                <div key={label} className='flex flex-col items-center mx-1 px-1'>
                  <div
                    onClick={onClick}
                    className="h-8 w-8 flex justify-center items-center rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-lg shadow-black"
                    title={`Create New ${label}`}
                  >
                    <IconComp className="h-7 w-7 text-white" />
                  </div>
                  <div>
                    <p className="text-[9px] mt-1 pt-1">{label}</p>
                  </div>
                </div>
              ))}
          </div>    
        </div>  
      )}

      {syncMessage && (
        <p
          className={`mt-2 transition-opacity duration-500 ease-in-out ${
            fadeOut ? "opacity-0" : "opacity-100"
          } ${syncMessage.type === "success" ? "text-lime-600" : "text-red-600"}`}
        >
          {syncMessage.text}
        </p>
      )}
     
      {isSyncing && <p>Loading...</p>}
      {error && <p className="text-red-500">Failed to fetch events</p>}

        <div className='grid grid-cols-3 justify-between items-start py-3 space-x-1 font-poppins'>
          {/* Panel 1 - Perform! */}
          <div 
            onClick={() => setActiveTab("perform")}
            className={`col-span-1 rounded`}
          >
            <div className={`text-gray-500 flex justify-between items-center bg-black rounded font-bold cursor-pointer py-5  ${
              activeTab === "perform" ? "text-orange-600" : "text-white"
            }`}>
              <div className='flex justify-start items-center'>
                  <div className='mx-1 px-1'><EtPerformIconSVGComp className='h-8 w-8'/></div>
                  <div>
                    <p className='mx-1 px-1'>Perform!</p>
                    <p className='mx-1 px-1 text-xs italic font-normal'>do it like a rockstar!</p>
                  </div>
              </div>
              
              {/* Selection Tab - Meetings, Actions */}
              <div className='flex justify-start items-center mx-2 px-2'>
                <div 
                  className={`mx-2 px-2 cursor-pointer ${activePerformSubTab === "meetings" ? "text-orange-600" :"text-gray-400"}`}
                  onClick={(e) => {
                    e.stopPropagation();  // Prevent parent panel tab change
                    setActivePerformSubTab("meetings");
                  }}
                  >
                    <EtWabConversationIcon1SVGComp className='h-10 w-10' />
                    <p className='text-[10px]'>Meetings</p>
                </div>
                <div 
                  className={`mx-2 px-2 cursor-pointer ${activePerformSubTab === "actions" ? "text-orange-600" :"text-gray-400"}`}
                  onClick={() => setActivePerformSubTab("actions")}
                  >
                    <EtWabActionIcon1SVGComp className='h-10 w-10' />
                    <p className='text-[10px]'>Actions</p>
                </div>
              </div> 

            </div>
            {(
              // 03 Apr 2025
              <Perform
                activeTab={activeTab}
                meetings={meetingsToday}
                meetingPreps={meetingPrepsToday}
                activeSubTab={activePerformSubTab}
                actions={actionsToday} 
                refetchUserActions={refetchUserActions} // 04 Apr 2025
                trails={trails} // 05 Apr 2025
                relevantContacts={relevantContacts} // 12 Jun 2025
              />
            )}
          </div>

          {/* Panel 2 - Prepare! */}
          <div 
            onClick={() => setActiveTab("prepare")}
            className={`col-span-1 rounded`}
          >
            <div className={`text-gray-500 flex justify-between items-center bg-black rounded font-bold cursor-pointer py-5 ${
              activeTab === "prepare" ? "text-orange-600" : "text-white"
            }`}>
              <div className='flex justify-start items-center'>
                  <div className='mx-1 px-1'><EtPrepareIconSVGComp className='h-8 w-8'/></div>
                  <div>
                      <p className='mx-1 px-1'>Prepare!</p>
                      <p className='mx-1 px-1 text-xs italic font-normal'>steal your upcoming shows!</p>
                  </div>
              </div>
              {/* Selection Tab - Meetings, Actions */}

              <div className='flex justify-start items-center mx-2 px-2'>
                <div 
                  className={`mx-2 px-2 cursor-pointer ${activePrepareSubTab === "meetings" ? "text-orange-600" :"text-gray-400"}`}
                  onClick={(e) => {
                    e.stopPropagation();  // Prevent parent panel tab change
                    setActivePrepareSubTab("meetings");
                  }}
                  >
                    <EtWabConversationIcon1SVGComp className='h-10 w-10' />
                    <p className='text-[10px]'>Meetings</p>
                </div>
                <div 
                  className={`mx-2 px-2 cursor-pointer ${activePrepareSubTab === "actions" ? "text-orange-600" :"text-gray-400"}`}
                  onClick={() => setActivePrepareSubTab("actions")}
                  >
                    <EtWabActionIcon1SVGComp className='h-10 w-10' />
                    <p className='text-[10px]'>Actions</p>
                </div>
              </div> 

            </div>
            {(
              // 03 Apr 2025
              <Prepare
                activeTab={activeTab}
                meetings={meetingsThisMonth}
                meetingPreps={meetingPrepsThisMonth}
                activeSubTab={activePrepareSubTab}
                actions={actionsThisMonth}
                refetchUserActions={refetchUserActions} // 04 Apr 2025
                trails={trails} // 05 Apr 2025
                relevantContacts={relevantContacts} // 12 Jun 2025
              />
            )}
          </div>

          {/* Panel 3 - Plan! */}
          <div 
            onClick={() => setActiveTab("plan")}
            className={`col-span-1 rounded `}
          >
            <div className={`text-gray-500 flex justify-between items-center bg-black rounded font-bold cursor-pointer py-5 ${
              activeTab === "plan" ? "text-orange-600" : "text-white"
            }`}>
              <div className='flex justify-start items-center'>
                  <div className='mx-1 px-1'><EtPlanIconSVGComp className='h-8 w-8'/></div>
                  <div>
                    <p className='mx-1 px-1'>Plan!</p>
                    <p className='mx-1 px-1 text-xs italic font-normal'>stay ahead like a pro!</p>
                  </div>
              </div>
              {/* Selection Tab - Meetings, Actions */}

              <div className='flex justify-start items-center mx-2 px-2'>
                <div 
                  className={`mx-2 px-2 cursor-pointer ${activePlanSubTab === "meetings" ? "text-orange-600" :"text-gray-400"}`}
                  onClick={(e) => {
                    e.stopPropagation();  // Prevent parent panel tab change
                    setActivePlanSubTab("meetings");
                  }}
                  >
                    <EtWabConversationIcon1SVGComp className='h-10 w-10' />
                    <p className='text-[10px]'>Meetings</p>
                </div>
                <div 
                  className={`mx-2 px-2 cursor-pointer ${activePlanSubTab === "actions" ? "text-orange-600" :"text-gray-400"}`}
                  onClick={() => setActivePlanSubTab("actions")}
                  >
                    <EtWabActionIcon1SVGComp className='h-10 w-10' />
                    <p className='text-[10px]'>Actions</p>
                </div>
              </div> 

            </div>
            {(
              // <Plan activeTab={activeTab} meetings={futureMeetings} meetingPreps={futureMeetingPreps}/>
              // 03 Apr 2025
              <Plan
                activeTab={activeTab}
                meetings={futureMeetings}
                meetingPreps={futureMeetingPreps}
                activeSubTab={activePlanSubTab}
                actions={actionsFuture}
                refetchUserActions={refetchUserActions} // 04 Apr 2025
                trails={trails} // 05 Apr 2025
                relevantContacts={relevantContacts} // 12 Jun 2025
              />
            )}
          </div>
        </div>
        {/* 08 Apr 2025 - Modal for creating a new user action */}
        <EtModalCreateUserActionLanding
          showModal={showCreateActionModal}
          onClose={() => setShowCreateActionModal(false)}
          refetchUserActions={refetchUserActions}
        />
        {/* 08 Apr 2025 - Modal for creating a new user creation */}
        <EtModalCreateUserImprintCreation
          isOpen={showCreateCreationModal}
          userId={userId}
          userOrgId={userOrgId}
          triggeringUrl={"/etapp"}
          onClose={() => setShowCreateCreationModal(false)}
          refetchOnSuccess={refetchUserCreations} 
        />
        {/* 08 Apr 2025 - Modal for creating a new user gratitude */}
        <EtModalCreateUserImprintGratitude
          isOpen={showCreateGratitudeModal}
          userId={userId}
          userOrgId={userOrgId}
          triggeringUrl={"/etapp"}
          onClose={() => setShowCreateGratitudeModal(false)}
          refetchOnSuccess={refetchUserGratitudes} 
        />
        {/* 08 Apr 2025 - Modal for creating a new user contribution */}
        <EtModalCreateUserContributionLanding
          isOpen={showCreateContributionModal}
          onClose={() => setShowCreateContributionModal(false)}
          userId={userId}
          userOrgId={userOrgId}
          refetchUserContributions={refetchUserContributions}
        />
        {/* 08 Apr 2025 - Modal for creating a new user impact */}
        <EtModalCreateUserImpactLanding
          isOpen={showCreateImpactModal}
          onClose={() => setShowCreateImpactModal(false)}
          userId={userId}
          userOrgId={userOrgId}
          refetchUserImpacts={refetchUserImpacts}
        />
        {/* 08 Apr 2025 - Modal for creating a new user win */}
        <EtModalCreateUserWinLanding
          isOpen={showCreateWinModal}
          onClose={() => setShowCreateWinModal(false)}
          userId={userId}
          userOrgId={userOrgId}
          refetchUserWins={refetchUserWins}
        />
        {/* 08 Apr 2025 - Modal for creating a new user intention */}
        <EtModalCreateUserIntentionLanding
          isOpen={showCreateIntentionModal}
          onClose={() => setShowCreateIntentionModal(false)}
          userId={userId}
          userOrgId={userOrgId}
          refetchUserIntentions={refetchUserIntentions}
        />
        {/* 08 Apr 2025 - Modal for creating a new user challengeWAB */}
        <EtModalCreateUserChallengeWABLanding
          isOpen={showCreateChallengeWABModal}
          onClose={() => setShowCreateChallengeWABModal(false)}
          userId={userId}
          userOrgId={userOrgId}
          refetchUserChallengeWABs={refetchUserChallengeWABs}
        />
        {/* 09 Apr 2025 - Modal for creating a new user conversation (without calendar meetings) */}
        <EtModalCreateUserConversationLanding
          isOpen={showCreateConversationModal}
          onClose={() => setShowCreateConversationModal(false)}
          userId={userId}
          userOrgId={userOrgId}
          // refetchUserConversations={refetchUserConversations}
        />
    </div>
  )
}

const Perform = ({activeTab, meetings = [], activeSubTab="meetings", meetingPreps=[], actions=[],refetchUserActions, trails, relevantContacts=[]}) => {
  // Author - Atul Pandey
  // First Created - 12 Mar 2025
  // Purpose - To capture all the tasks related to a user's daily routine
  // Updated - 14 Mar 2025 - added meetings prop
  // Updated - 20 Mar 2025 - added show / hide - attendees
  // Updated - 03 Apr 2025 - added activeSubTab
  // Updated - 03 Apr 2025 - added actions
  // Updated - 04 Apr 2025 - added refetchUserActions
  // Updated - 05 Apr 2025 - Added section for filtering actions by trails
  // Updated - 05 Apr 2025 - Added feature for creating a new Action
  // Updated - 08 Apr 2025 - Moved feature for creating a new Action to EtTrinityWebLandingAction
  // Updated - 12 Jun 2025 - Switched from MeetinngCard to EtMeetingCard


  // 0 - validate incoming data
  // console.log('meetings today', meetings)
  // console.log('meeting preps today', meetingPreps)
  // console.log('actions today', actions)

  // 1 - State variables to show / hide sections
  const [ showAttendees, setShowAttendees ] = useState({}) // 20 Mar 2025
  const [ showDetails, setShowDetails ] = useState({}) // 20 Mar 2025
  const [selectedTrail, setSelectedTrail] = useState("all") // 05 Apr 2025

  const [selectedMeetingId, setSelectedMeetingId] = useState(null); // 12 Jun 2025
  
  // 2a - Toggle Show function for event details
  const handleToggleAttendees = (eventId) => {
    setShowAttendees(prev => ({ ...prev, [eventId]: !prev[eventId] }));
  }

  // 2b - Toggle Show function for event details
  const handleToggleDetails = (eventId) => {
    setShowDetails(prev => ({ ...prev, [eventId]: !prev[eventId] }));
  }

  // 2c - Filtered actions - 05 Apr 2025
  const filteredActions = selectedTrail === "all"
  ? actions
  : actions?.filter(action => action?.trailId?.trailName === selectedTrail)

  // 2d - Compute only trails that are in use by actions - 05 Apr 2025
  const usedTrailNames = Array.from(
    new Set(actions?.map(action => action?.trailId?.trailName))
  )


  return(
    <div className={`rounded my-1 pb-1 border bg-gray-300 h-[350px] overflow-y-auto font-poppins ${activeTab === 'perform' ? 'border bg-orange-600': ''}`}>
      {/* Fetch and show all the meetings from user's calendar */}
      <div className="h-full">
        <div className='p-4'>
          <div className='flex justify-between items-center'>
            <p className={`font-bold ${activeTab === 'perform' ? 'text-white': ''}`}>
              {activeSubTab === "meetings" ? "Your Meetings Today:" : "Your Actions Today:"}
            </p>
            
            {/* 3 - Trail Filter Dropdown */}
            {activeSubTab === "actions" && (
              <div className="my-2 flex justify-start items-center">
                <div className='flex justify-start items-center'>
                  <ArrowTrendingUpIcon className={`w-4 h-4  ${activeTab === 'perform' ? 'text-white': ''}`}/>
                  <p className={`mx-1 px-1 text-[10px]  ${activeTab === 'perform' ? 'text-white': ''}`}>Trail:</p>
                </div>
                <select
                  value={selectedTrail}
                  onChange={(e) => setSelectedTrail(e.target.value)}
                  className="text-[10px] rounded border-none ring-0 px-2 py-1"
                >
                  <option value="all">All Trails</option>
                  {trails
                    ?.filter(trail => usedTrailNames.includes(trail.trailName))
                    ?.map(trail => (
                      <option key={trail._id} value={trail.trailName}>
                        {trail.trailName}
                      </option>
                  ))}
                </select>
              </div>
            )}

            <div className={`flex justify-center items-center rounded-full w-8 h-8 border ${activeTab === 'perform' ? 'border border-white': 'border-black'}`}>
              <p className={`font-bold ${activeTab === 'perform' ? 'text-white': ''}`}>{activeSubTab === "meetings" ? meetings?.length : filteredActions?.length}</p>
            </div>
          </div>
     
        </div>

        { activeSubTab === "meetings" ? (
          meetings?.length > 0 ? (
            meetings
              ?.slice()
              ?.sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
              ?.map((event, index) => {
                const matchingPrep = meetingPreps?.find(prep => prep?.calendarMeetingId?._id === event?._id);
                // console.log('matchingPrep Today',matchingPrep)
                return(
                // <MeetingCard
                //   key={`${event.eventId}-${index}`}
                //   event={event}
                //   index={index}
                //   activeTab={activeTab}
                //   matchingPrep={matchingPrep}
                // />
                <EtMeetingCard
                  key={event._id}
                  event={event}
                  index={index}
                  activeTab={activeTab}
                  matchingPrep={matchingPrep}
                  isActive={selectedMeetingId === event._id}
                  onClick={() => setSelectedMeetingId(event._id)}
                  // userEmail={userEmail} 
                  relevantContacts={relevantContacts}
                />
              )})
          ) : (
            <div className='bg-white rounded m-1 p-1'>
              <p className='p-8 text-sm'>No events found</p>
            </div>
          )

        ):(
          
          filteredActions?.length > 0 ? (
            filteredActions
            ?.slice()
            ?.sort((a, b) => new Date(a.completeBy) - new Date(b.completeBy))
            ?.map((action, actionIndex) => {
              const actionName = action?.userActionName || ""
              return(
                <div key={action._id+actionIndex}>
                  <ActionCard 
                    action={action} 
                    actionIndex={actionIndex} 
                    refetchUserActions={refetchUserActions} // 04 Apr 2025
                  />
                </div>
              )
            })
          )
          :(
            <div className='bg-white rounded m-1 p-1'>
              <p className='p-8 text-sm italic text-gray-500'>
                Actions will appear here soon...
            </p>
          </div>)
          
        )}
      </div>
      
    </div>
  )

}

const Prepare = ({activeTab, meetings = [], activeSubTab="meetings", meetingPreps=[], isEndOfMonth=false, actions=[],refetchUserActions, trails, relevantContacts=[]}) => {

    // Author - Atul Pandey
    // First Created - 12 Mar 2025
    // Purpose - To capture all the tasks related to a user's upcoming meetings
    // Updated - 31 Mar 2025 - added isEndOfMonth prop
    // Updated - 03 Apr 2025 - added activeSubTab
    // Updated - 03 Apr 2025 - added actions
    // Updated - 04 Apr 2025 - added refetchUserActions
    // Updated - 05 Apr 2025 - Added section for filtering actions by trails
    // Updated - 12 Jun 2025 - Switched from MeetinngCard to EtMeetingCard

    // 0 - validate incoming data
    // console.log('meetings next week', meetings)
    // console.log('meeting preps next week', meetingPreps)

    // 1 - State variables to show / hide sections
    const [ showAttendees, setShowAttendees ] = useState({}) // 20 Mar 2025
    const [selectedTrail, setSelectedTrail] = useState("all") // 05 Apr 2025

    const [selectedMeetingId, setSelectedMeetingId] = useState(null); // 12 Jun 2025

    // 2a - Toggle Show function for event details
    const handleToggleAttendees = (eventId) => {
      setShowAttendees(prev => ({ ...prev, [eventId]: !prev[eventId] }));
    }

    // 2b - Filtered actions - 05 Apr 2025
    const filteredActions = selectedTrail === "all"
    ? actions
    : actions?.filter(action => action?.trailId?.trailName === selectedTrail)

    // 2c - Compute only trails that are in use by actions - 05 Apr 2025
    const usedTrailNames = Array.from(
      new Set(actions?.map(action => action?.trailId?.trailName))
    )

    return(
      <div className={`rounded my-1 pb-1 border bg-gray-300 h-[350px] overflow-y-auto font-poppins ${activeTab === 'prepare' ? 'border bg-orange-600': ''}`}>
        {/* Fetch and show all the meetings from user's calendar */}
        <div className="h-full">
          <div className='p-4'>
            <div className='flex justify-between items-center'>
              <p className={`font-bold ${activeTab === 'prepare' ? 'text-white': ''}`}>
                {activeSubTab === "meetings"
                  ? isEndOfMonth
                    ? "Your Meetings for Upcoming Month:"
                    : "Your Meetings This Month:"
                  : isEndOfMonth
                    ? "Your Actions for Upcoming Month:"
                    : "Your Actions This Month:"
                }
              </p>

              {/* 3 - Trail Filter Dropdown */}
                {activeSubTab === "actions" && (
                  <div className="my-2 flex justify-start items-center">
                    <div className='flex justify-start items-center'>
                      <ArrowTrendingUpIcon className={`w-4 h-4  ${activeTab === 'prepare' ? 'text-white': ''}`}/>
                      <p className={`mx-1 px-1 text-[10px]  ${activeTab === 'prepare' ? 'text-white': ''}`}>Trail:</p>
                    </div>
                    <select
                      value={selectedTrail}
                      onChange={(e) => setSelectedTrail(e.target.value)}
                      className="text-[10px] rounded border-none ring-0 px-2 py-1"
                    >
                      <option value="all">All Trails</option>
                      {trails
                        ?.filter(trail => usedTrailNames.includes(trail.trailName))
                        ?.map(trail => (
                          <option key={trail._id} value={trail.trailName}>
                            {trail.trailName}
                          </option>
                      ))}
                    </select>
                  </div>
                )}

              <div className={`flex justify-center items-center rounded-full w-8 h-8 border ${activeTab === 'prepare' ? 'border border-white': 'border-black'}`}>
                <p className={`font-bold ${activeTab === 'prepare' ? 'text-white': ''}`}>{activeSubTab === "meetings" ? meetings?.length : filteredActions?.length}</p>
              </div>
              
            </div>
            
          </div>
            
          { activeSubTab === "meetings" ? (
          meetings?.length > 0 ? (
            meetings
              ?.slice()
              ?.sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
              ?.map((event, index) => {
                const matchingPrep = meetingPreps?.find(prep => prep?.calendarMeetingId?._id === event?._id);
                // console.log('matchingPrep Today',matchingPrep)
                return(
                // <MeetingCard
                //   key={`${event.eventId}-${index}`}
                //   event={event}
                //   index={index}
                //   activeTab={activeTab}
                //   matchingPrep={matchingPrep}
                // />
                <EtMeetingCard
                  key={event._id}
                  event={event}
                  index={index}
                  activeTab={activeTab}
                  matchingPrep={matchingPrep}
                  isActive={selectedMeetingId === event._id}
                  onClick={() => setSelectedMeetingId(event._id)}
                  // userEmail={userEmail} 
                  relevantContacts={relevantContacts}
                />
              )})
          ) : (
            <div className='bg-white rounded m-1 p-1'>
              <p className='p-8 text-sm'>No events found</p>
            </div>
          )

            ):(
              
              filteredActions?.length > 0 ? (
                filteredActions
                ?.slice()
                ?.sort((a, b) => new Date(a.completeBy) - new Date(b.completeBy))
                ?.map((action, actionIndex) => {
                  const actionName = action?.userActionName || ""
                  return(
                    <div key={action._id+actionIndex}>
                      <ActionCard 
                        action={action} 
                        actionIndex={actionIndex} 
                        refetchUserActions={refetchUserActions} // 04 Apr 2025
                      />
                    </div>
                  )
                })
              )
              :(
                <div className='bg-white rounded m-1 p-1'>
                  <p className='p-8 text-sm italic text-gray-500'>
                    Actions will appear here soon...
                </p>
              </div>)
              
            )}
        </div>
      </div>
    )
}

const Plan = ({activeTab, meetings = [], activeSubTab="meetings",  meetingPreps=[], actions=[],refetchUserActions, trails, relevantContacts=[]}) => {

    // Author - Atul Pandey
    // First Created - 12 Mar 2025
    // Purpose - To capture all the tasks related to a user's daily routine
    // Updated - 03 Apr 2025 - added activeSubTab
    // Updated - 03 Apr 2025 - added actions
    // Updated - 04 Apr 2025 - added refetchUserActions
    // Updated - 05 Apr 2025 - Added section for filtering actions by trails
    // Updated - 12 Jun 2025 - Switched from MeetinngCard to EtMeetingCard

    // 1 - validate incoming data
    // console.log('future meetings', meetings)
    // console.log('future meeting preps', meetingPreps)


    // 1 - State variables to show / hide sections
    const [ showAttendees, setShowAttendees ] = useState({}) // 20 Mar 2025
    const [selectedTrail, setSelectedTrail] = useState("all") // 05 Apr 2025

    const [selectedMeetingId, setSelectedMeetingId] = useState(null); // 12 Jun 2025

    // 2a - Toggle Show function for event details
    const handleToggleAttendees = (eventId) => {
      setShowAttendees(prev => ({ ...prev, [eventId]: !prev[eventId] }));
    }

    // 2b - Filtered actions - 05 Apr 2025
    const filteredActions = selectedTrail === "all"
    ? actions
    : actions?.filter(action => action?.trailId?.trailName === selectedTrail)

    // 2c - Compute only trails that are in use by actions - 05 Apr 2025
    const usedTrailNames = Array.from(
      new Set(actions?.map(action => action?.trailId?.trailName))
    )

    return(
      <div className={`rounded my-1 pb-1 border bg-gray-300 h-[350px] overflow-y-auto font-poppins ${activeTab === 'plan' ? 'border bg-orange-600': ''}`}>
        {/* Fetch and show all the meetings from user's calendar */}
        <div className="h-full">
          <div className='p-4'>
            <div className='flex justify-between items-center'>
              <p className={`font-bold ${activeTab === 'plan' ? 'text-white': ''}`}>
                {/* Your Future Meetings: */}
                {activeSubTab === "meetings" ? "Your Future Meetings:" : "Your Future Actions:"}
              </p>

               {/* 3 - Trail Filter Dropdown */}
               {activeSubTab === "actions" && (
                  <div className="my-2 flex justify-start items-center">
                    <div className='flex justify-start items-center'>
                      <ArrowTrendingUpIcon className={`w-4 h-4  ${activeTab === 'plan' ? 'text-white': ''}`}/>
                      <p className={`mx-1 px-1 text-[10px]  ${activeTab === 'plan' ? 'text-white': ''}`}>Trail:</p>
                    </div>
                    <select
                      value={selectedTrail}
                      onChange={(e) => setSelectedTrail(e.target.value)}
                      className="text-[10px] rounded border-none ring-0 px-2 py-1"
                    >
                      <option value="all">All Trails</option>
                      {trails
                        ?.filter(trail => usedTrailNames.includes(trail.trailName))
                        ?.map(trail => (
                          <option key={trail._id} value={trail.trailName}>
                            {trail.trailName}
                          </option>
                      ))}
                    </select>
                  </div>
                )}

              <div className={`flex justify-center items-center rounded-full w-8 h-8 border ${activeTab === 'plan' ? 'border border-white': 'border-black'}`}>
                <p className={`font-bold ${activeTab === 'plan' ? 'text-white': ''}`}>{activeSubTab === "meetings" ? meetings?.length : filteredActions?.length}</p>
              </div>     
            </div>
            
          </div>

          { activeSubTab === "meetings" ? (
            meetings?.length > 0 ? (
              meetings
                ?.slice()
                ?.sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
                ?.map((event, index) => {
                  const matchingPrep = meetingPreps?.find(prep => prep?.calendarMeetingId?._id === event?._id);
                  // console.log('matchingPrep Today',matchingPrep)
                  return(
                  // <MeetingCard
                  //   key={`${event.eventId}-${index}`}
                  //   event={event}
                  //   index={index}
                  //   activeTab={activeTab}
                  //   matchingPrep={matchingPrep}
                  // />
                  <EtMeetingCard
                  key={event._id}
                  event={event}
                  index={index}
                  activeTab={activeTab}
                  matchingPrep={matchingPrep}
                  isActive={selectedMeetingId === event._id}
                  onClick={() => setSelectedMeetingId(event._id)}
                  // userEmail={userEmail} 
                  relevantContacts={relevantContacts}
                />
                )})
            ) : (
              <div className='bg-white rounded m-1 p-1'>
                <p className='p-8 text-sm'>No events found</p>
              </div>
            )

              ):(
              
              filteredActions?.length > 0 ? (
                filteredActions
                ?.slice()
                ?.sort((a, b) => new Date(a.completeBy) - new Date(b.completeBy))
                ?.map((action, actionIndex) => {
                  const actionName = action?.userActionName || ""
                  return(
                    <div key={action._id+actionIndex}>
                      <ActionCard 
                        action={action} 
                        actionIndex={actionIndex} 
                        refetchUserActions={refetchUserActions} // 04 Apr 2025
                      />
                    </div>
                  )
                })
              )
              :(
                <div className='bg-white rounded m-1 p-1'>
                  <p className='p-8 text-sm italic text-gray-500'>
                    Actions will appear here soon...
                </p>
              </div>)    
            )}
        </div>
      </div>
    )
}

export const MeetingCard = ({ event, index, activeTab, matchingPrep=[] }) => {
  // Author - Atul Pandey
  // First Created - 21 Mar 2025
  // Purpose - To display each event details
  // Updated - 22 Mar 2025 - To edit or delete a specific note
  // Updated - 22 Mar 2025 - Post Meeting actions section
  // Updated - 23 Mar 2025 - Post Meeting Conversations capture and display
  // Updated - 25 Mar 2025 - Post Meeting Conversations - show conversation details
  
  // 0 - Validate incoming data
  // console.log('matchingPrep in MeetingCard', matchingPrep)
  // console.log('event id in MeetingCard', event?._id)
  // console.log('matchingPrep id in MeetingCare', matchingPrep?._id)

  // 1 - State variables
  const [showAttendees, setShowAttendees] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [showNoteDetails, setShowNoteDetails] = useState({})
  const [showModal, setShowModal] = useState(false);
  const [selectedNoteId, setSelectedNoteId] = useState(null);  // ✅ 22 Mar 2025 - new
  const [isDeletingNote, setIsDeletingNote] = useState(false); // ✅ 22 Mar 2025 - new
  const [activePostTab, setActivePostTab] = useState('conversations') // ✅ 22 Mar 2025 - new
  const [showConversationModal, setShowConversationModal] = useState(false); // ✅ 23 Mar 2025 - new
  
  const [showConversationDetails, setShowConversationDetails] = useState({}) // ✅ 25 Mar 2025 - new
  const [selectedConversationNoteId, setSelectedConversationNoteId] = useState(null);  // ✅ 25 Mar 2025 - new
  const [isDeletingConversationNote, setIsDeletingConversationNote] = useState(false); // ✅ 25 Mar 2025 - new

  // 2 - Get Data 
  const { 
    data: userConversationsData,
    isLoading: isLoadingUserConversations, // ✅ 25 Mar 2025
    refetch: refetchUserConversations // ✅ 25 Mar 2025 Extract refetch
  
  } = useGetUserConversationsQuery() //  ✅ 23 Mar 2025 - Fetch all user conversations
  // console.log('User Conversations Data', userConversationsData)
  
  // ✅ Filter conversations that belong to this meeting (by meetingPrepId or calendarMeetingId)
  const extractMeetingConversations = () => {
    if (!userConversationsData?.ids?.length || !userConversationsData?.entities) return [];
  
    const allNotes = [];
  
    userConversationsData?.ids.forEach((id) => {
      const conv = userConversationsData.entities[id];
  
      // 1️⃣ Process self notes
      (conv?.userConversationAllNotes || [])?.forEach((note) => {
        if (
          note.calendarMeetingId === event._id ||
          note.userMeetingPrepId === matchingPrep?._id
        ) {
          allNotes.push({
            ...note,
            noteType: 'self',
          });
        }
      });
  
      // 2️⃣ Process contact notes
      (conv?.userConversationContactNotes || [])?.forEach((note) => {
        if (
          note.calendarMeetingId === event._id ||
          note.userMeetingPrepId === matchingPrep?._id
        ) {
          allNotes.push({
            ...note,
            noteType: 'contact',
            contactName: note.userContactId?.contactName || '',
            contactType: note.userContactId?.contactTypeId?.contactTypeName || '',
          });
        }
      });
    });
  
    // 3️⃣ Sort by most recently updated
    return allNotes.sort(
      (a, b) =>
        new Date(b.userConversationNoteUpdateDate) - new Date(a.userConversationNoteUpdateDate)
    );
  };
  
  const meetingConversations = extractMeetingConversations();
  console.log('meeting conversations', meetingConversations)
  
  // 3 - Functions
  const toggleDetails = () => setShowDetails(prev => !prev)
  const toggleAttendees = () => setShowAttendees(prev => !prev)

  // 23 Mar 2025
  const handleToggleNoteDetails = (noteId) => {
    setShowNoteDetails((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }
  
  // 25 Mar 2025
  const handleToggleConversationDetails = (noteId) => {
    setShowConversationDetails((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }
  

  // 4 - create Markup
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

  return (
    <div className='bg-white rounded m-1 p-1 font-poppins'>
      {/* Header */}
      <div className='flex justify-start items-center'>
        <div
          className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
          onClick={toggleDetails}
        >
          {showDetails ? (
            <MinusIcon className="h-4 w-4 text-orange-600" />
          ) : (
            <PlusIcon className="h-4 w-4 text-orange-600" />
          )}
        </div>
        <p className='text-lg m-1 p-1 font-bold text-gray-600'>{index + 1}.</p>
        <p className='text-xs m-1 p-1 font-bold text-gray-600'>{event.title}</p>
      </div>

      {/* Time */}
      <div className='flex justify-between items-center m-1 p-1 border-t'>
        <div className='flex justify-start items-center my-1 py-1'>
          <CalendarDaysIcon className='w-4 h-4 text-orange-600' />
          <p className='text-xs mx-1 px-1 text-orange-600'>
            {moment(event.startTime).isSame(moment(), 'day') ? "Today" : moment(event.startTime).format("DD MMM YYYY (ddd)")}
          </p>
        </div>
        <div className='flex justify-end items-center my-1 py-1'>
          <div className='flex items-center'>
            <ClockIcon className='text-lime-600 h-4 w-4' />
            <p className='text-xs mx-1 px-1'>Start: {moment(event.startTime).format("hh:mm A")}</p>
          </div>
          <div className='flex items-center'>
            <ClockIcon className='text-orange-600 h-4 w-4' />
            <p className='text-xs mx-1 px-1'>End: {moment(event.endTime).format("hh:mm A")}</p>
          </div>
        </div>
      </div>

      {/* Expandable Details */}
      {showDetails && (
          <div className='border-t m-1 p-1'>
            {/* Attendees */}
            <div className='p-2 flex justify-start items-center'>
              <div
                className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                onClick={toggleAttendees}
              >
                {showAttendees ? (
                  <MinusIcon className="h-4 w-4 text-orange-600" />
                ) : (
                  <PlusIcon className="h-4 w-4 text-orange-600" />
                )}
              </div>
              <UserGroupIcon className='h-5 w-5 text-orange-600' />
              <p className='text-sm font-bold mx-1 px-1'>Attendees:</p>
              <p className='text-xs text-gray-400 italic px-1'>
                {event?.attendees?.length} attendee{event?.attendees?.length !== 1 ? "s" : ""}
              </p>
            </div>

            {showAttendees && event?.attendees?.length > 0 && (
              event.attendees.map((attendee, i) => (
                <div key={`${attendee.email}-${i}`} className='bg-gray-300 rounded m-1 p-1'>
                  <div className='flex justify-start items-center'>
                    {/* <User
                      username={attendee?.username}
                      defaultUserPic={userProfileIcon2}
                    /> */}
                    <p className='text-[10px] mx-1 px-1 font-bold'>{i + 1}.</p>
                    <p className='text-[10px] mx-1 px-1'>{attendee?.email}</p>
                  </div>
                </div>
              ))
            )}

            {/* Show Prep */}
            {/* Meeting Prep Section */}
            <div className='border-t my-1 py-1'>
              <div className='flex justify-between items-center m-1 p-1'>
                <div className='flex justify-start items-center'>
                  <EtMeetingIcon1SVGComp className='h-6 w-6 text-orange-600' />
                  <p className='text-sm font-bold text-gray-600 mx-1 px-1'>Meeting Prep Trail</p>
                </div>
                <div className='flex justify-end items-center'>
                  <p className='text-xs font-bold mx-1 px-1'>Add</p>
                  <button
                    className="flex items-center bg-lime-500 text-white p-1 rounded text-xs hover:bg-lime-600"
                    onClick={() => setShowModal(true)}
                  >
                    <PlusIcon className="h-4 w-4" />
                  </button>
                </div>
                  
              </div>
              
              {/* Prep Notes Trail Section */}
              {matchingPrep?.meetingPrepNotes?.length > 0 ? (
                matchingPrep?.meetingPrepNotes
                ?.slice()
                  .sort(
                    (a, b) =>
                        new Date(b.meetingPrepNoteUpdateDate) - new Date(a.meetingPrepNoteUpdateDate)
                ) // Sort in descending order
                ?.map((note, i) => {

                    const noteText = note?.meetingPrepNoteText || ""
                    const noteDate = note?.meetingPrepNoteDate || ""
                    const noteUpdateDate = note?.meetingPrepNoteUpdateDate || ""
                    // console.log('noteText', noteText)
                  
                    return (
                  <div key={note._id+i} className="">

                    <div className='bg-gray-200 rounded grid grid-cols-11 justify-start items-center m-1 p-1'>
                      <div className="col-span-4 flex justify-start items-center">
                        <div
                          onClick={() => handleToggleNoteDetails(note._id)}
                          className="rounded-full h-6 w-6 hover:bg-white flex justify-center items-center cursor-pointer"
                        >
                          {showNoteDetails[note._id] ? (
                            <MinusIcon className="h-4 w-4 text-orange-600" />
                          ) : (
                            <PlusIcon className="h-4 w-4 text-orange-600" />
                          )}
                        </div>
                        <div>
                          <p className="text-sm font-bold mx-1 px-1 text-gray-600">{ i +1}.</p>
                        </div>
                        <div className="">
                          <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                            {getTimeSince(noteUpdateDate)}
                          </p>
                          <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-400">last updated</p>
                        </div>
                      </div>

                      <div className="col-span-6 flex justify-start items-center">
                        <div
                          dangerouslySetInnerHTML={createMarkup(noteText)}
                          className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
                        ></div>
                      </div>

                      <div className="col-span-1 flex justify-start items-center">
                        <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                          <PencilSquareIcon
                            className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                            onClick={() => {
                              setSelectedNoteId(note._id); // ✅ Set noteId for editing
                              setShowModal(true);
                            }}
                          />
                        </div>
                        <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                          <TrashIcon
                            className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                            onClick={() => {
                              setSelectedNoteId(note._id); // ✅ Set noteId for editing
                              setIsDeletingNote(true);     // ✅ Set flag for deleting
                              setShowModal(true);
                            }}
                          />
                        </div>
                      </div>
                      
                    </div>

                    {showNoteDetails[note._id] && (
                      <div className='bg-orange-50 rounded m-1 p-1 fix-nested-lists'>
                        <p dangerouslySetInnerHTML={createMarkup(noteText)} className='text-xs leading-4 m-1 p-1'></p>
                        <div className='flex justify-between items-center m-1 p-1 border-t'>
                          <div className='flex justify-start items-center my-1'>
                            <ClockIcon className="h-5 w-5 text-lime-600" />
                            <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                Created:
                            </p>
                            <p className="text-[10px] text-gray-500">
                               {moment(noteDate).format('DD MMM, hh:mm A')}
                            </p>
                          </div>
                          <div className='flex justify-start items-center my-1'>
                            <ClockIcon className="h-5 w-5 text-lime-600" />
                            <p className="text-[10px] text-gray-500 font-bold mx-1 px-1">
                                Updated:
                            </p>
                            <p className="text-[10px] text-gray-500">
                                {moment(noteUpdateDate).format('DD MMM, hh:mm A')}
                            </p>
                          </div>
                          
                        </div>  
                      </div>
                    )}         
                  </div>
                )})
              ) : (
                <p className="text-xs italic text-gray-500">No prep notes yet.</p>
              )}
            </div>

            {/* Post Meeting Actions */}
            <div className='border-t m-1 p-1'>
              <div className=''>
                <p className='text-sm font-bold text-gray-600 m-1 p-1'>Post Meeting Actions</p>
                
                {/* Action Areas -  */}
                <div className='flex justify-between items-center my-1 py-1 bg-gray-100'>
                  <div 
                    className='flex justify-start items-center mx-1 px-1 cursor-pointer'
                    onClick={() => setActivePostTab('conversations')}  
                  >
                      <EtWabConversationIcon1SVGComp className='h-6 w-6 text-orange-600'/>
                      <p className={`text-[10px] font-bold mx-1 ${activePostTab === 'conversations' ? 'border-b-2 border-orange-600': ''}`}>Conversations</p>
                  </div>
                  <div 
                    className='flex justify-start items-center mx-1 px-1 cursor-pointer'
                    onClick={() => setActivePostTab('actions')}
                  
                  >
                      <EtWabActionIcon1SVGComp className='h-6 w-6 text-orange-600'/>
                      <p className={`text-[10px] font-bold mx-1 ${activePostTab === 'actions' ? 'border-b-2 border-orange-600': ''}`}>Actions</p>
                  </div>
                  <div 
                    className='flex justify-start items-center mx-1 px-1 cursor-pointer'
                    onClick={() => setActivePostTab('transcript')}
                  
                  >
                      <ShareIcon className='h-4 w-4 text-orange-600'/>
                      <p className={`text-[10px] font-bold mx-1 ${activePostTab === 'transcript' ? 'border-b-2 border-orange-600': ''}`}>Transcript</p>
                  </div>
                </div>

                {activePostTab === 'conversations' && (
                  <div className="bg-white rounded p-2 text-xs mt-2">
                    <div className='flex justify-between items-center m-1 p-1'>
                      <div className='flex justify-start items-center'>
                        <EtMeetingIcon2SVGComp className='h-6 w-6 text-orange-600' />
                        <p className='text-sm font-bold text-gray-600 mx-1 px-1'>Conversations Trail</p>
                      </div>
                      <div className='flex justify-end items-center'>
                        <p className='text-xs font-bold mx-1 px-1'>Add</p>
                        <button
                          className="flex items-center bg-lime-500 text-white p-1 rounded text-xs hover:bg-lime-600"
                          onClick={() => setShowConversationModal(true)}
                        >
                          <PlusIcon className="h-4 w-4" />
                        </button>
                      </div>
                    </div>

                    {/* You can later replace this placeholder with an editor or conversation log component */}
                    {meetingConversations?.length > 0 ? (
                          meetingConversations
                          ?.slice()
                            .sort(
                              (a, b) =>
                                  new Date(b.userConversationAllNoteUpdateDate) - new Date(a.userConversationAllNoteUpdateDate)
                          ) // Sort in descending order
                          ?.map((note, idx) => {
                            const noteType = note?.noteType || ""
                            const contactName = note?.contactName || ""
                            const contactType = note?.contactType || ""
                            const noteText = note?.userConversationAllNoteText || ""
                            const noteDate = note?.userConversationAllNoteDate || ""
                            const noteUpdateDate = note?.userConversationAllNoteUpdateDate || ""
                            
                            // console.log('note conversation', note)

                            return (
                            <div key={note._id + idx} className="">

                                <div className='bg-gray-200 rounded grid grid-cols-11 justify-start items-center m-1 p-1'>
                                  <div className="col-span-4 flex justify-start items-center">
                                    <div
                                      onClick={() => handleToggleConversationDetails(note._id)}
                                      className="rounded-full h-6 w-6 hover:bg-white flex justify-center items-center cursor-pointer"
                                    >
                                      {showConversationDetails[note._id] ? (
                                        <MinusIcon className="h-4 w-4 text-orange-600" />
                                      ) : (
                                        <PlusIcon className="h-4 w-4 text-orange-600" />
                                      )}
                                    </div>
                                    <div>
                                      <p className="text-sm font-bold mx-1 px-1 text-gray-600">{ idx +1}.</p>
                                    </div>
                                    <div className="">
                                      <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                                        {getTimeSince(noteUpdateDate)}
                                      </p>
                                      <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-400">last updated</p>
                                    </div>
                                  </div>

                                  <div className="col-span-6 flex justify-start items-center">
                                    <div
                                      dangerouslySetInnerHTML={createMarkup(noteText)}
                                      className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
                                    ></div>
                                  </div>

                                  <div className="col-span-1 flex justify-start items-center">
                                    <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                      <PencilSquareIcon
                                        className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                                        onClick={() => {
                                          setSelectedConversationNoteId(note._id); // ✅ Set noteId for editing
                                          setShowConversationModal(true);
                                        }}
                                      />
                                    </div>
                                    <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                      <TrashIcon
                                        className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                                        onClick={() => {
                                          setSelectedConversationNoteId(note._id); // ✅ Set noteId for editing
                                          setIsDeletingConversationNote(true);     // ✅ Set flag for deleting
                                          setShowConversationModal(true);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {showConversationDetails[note._id] && (
                                    <div className='bg-orange-50 rounded m-1 p-1 fix-nested-lists'>
                                      <p dangerouslySetInnerHTML={createMarkup(noteText)} className='text-xs leading-4 m-1 p-1'></p>
                                      <div className='flex justify-between items-center m-1 p-1 border-t'>
                                        <div className='flex justify-start items-center my-1'>
                                          <ClockIcon className="h-5 w-5 text-lime-600" />
                                          <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                              Created:
                                          </p>
                                          <p className="text-[10px] text-gray-500">
                                            {moment(noteDate).format('DD MMM, hh:mm A')}
                                          </p>
                                        </div>
                                        <div className='flex justify-start items-center my-1'>
                                          <ClockIcon className="h-5 w-5 text-lime-600" />
                                          <p className="text-[10px] text-gray-500 font-bold mx-1 px-1">
                                              Updated:
                                          </p>
                                          <p className="text-[10px] text-gray-500">
                                              {moment(noteUpdateDate).format('DD MMM, hh:mm A')}
                                          </p>
                                        </div>   
                                      </div>  
                                    </div>
                                 )}  
                              </div>
                          )})
                        ) : (
                          <p className="text-xs italic text-gray-500 mt-2">No conversations added yet.</p>
                     )}
                  </div>
                )}

                {/* Placeholder for other tabs */}
                {activePostTab === "actions" && (
                  <div className="bg-gray-100 rounded mt-2 p-2">
                    <p className="text-xs italic text-gray-500">Actions coming soon...</p>
                  </div>
                )}
                {activePostTab === "transcript" && (
                  <div className="bg-gray-100 rounded mt-2 p-2">
                    <p className="text-xs italic text-gray-500">Transcript feature coming soon...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        
        {showModal && (
        <EtModalUpdateUserMeetingPrep
          isOpen={showModal}
          id={matchingPrep._id}
          noteId={selectedNoteId}   // ✅ 22 Mar 2025 - pass selected noteId
          isDelete={isDeletingNote} // ✅ 22 Mar 2025 - pass delete flag
          userId={matchingPrep.userId}
          userOrgId={matchingPrep.userOrgId}
          triggeringUrl={"/etapp"} // Or null, if staying on the same page
          onClose={() => {
            setShowModal(false);
            setSelectedNoteId(null); // ✅ 22 Mar 2025 - reset after modal close
            setIsDeletingNote(false) // ✅ 22 Mar 2025 - reset after modal close
          }}
        />)}
        {showConversationModal && (
          <EtModalTrinityUserMeetingConversation
            isOpen={showConversationModal}
            userId={matchingPrep?.userId}
            noteId={selectedConversationNoteId}
            isDelete={isDeletingConversationNote}
            userOrgId={matchingPrep?.userOrgId}
            calendarMeetingId={matchingPrep?.calendarMeetingId}
            userMeetingPrepId={matchingPrep?._id}
            onClose={() => {
              setShowConversationModal(false)
              setSelectedConversationNoteId(null); // ✅ 25 Mar 2025 - reset after modal close
              setIsDeletingConversationNote(false) // ✅ 25 Mar 2025 - reset after modal close
            }}
            refetchUserConversations={refetchUserConversations} // ✅ 25 Mar 2025
          />
        )}

    </div>
  )
}

const ActionCard = ({action, actionIndex, refetchUserActions}) => {
  // Author - Atul Pandey
  // First Created - 03 Apr 2025
  // Purpose - To display each action detail
  // Updated - 04 Apr 2025 - added edit features for an action
  // Updated - 04 Apr 2025 - added refetchActions prop from the parent

  // 0 - Validate incoming data
  // console.log('action in ActionCard', action)

  // 1 - State Variables
  const [showNoteDetails, setShowNoteDetails] = useState(false)
  const [showUpdateModal, setShowUpdateModal] = useState(false) // 04 Apr 2025
  const [selectedAction, setSelectedAction] = useState(null)    // 04 Apr 2025


  // 2 - Extract action data
  const actionName = action?.userActionName || ""
  const actionDesc = action?.userActionDesc || ""
  const actionProgress = action?.userActionProgress || 0
  const completeBy = action?.completeBy || ""
  const lastUpdated = action?.updatedAt || ""
  const actionNotes = action?.userActionNotes || []

  // 3 - 🧠 Hhelper function for Tracking Status
  const getTrackingStatus = () => {
    const daysToGo = moment(completeBy).startOf('day').diff(moment().startOf('day'), 'days');
    let status = 'Ok';
  let bgColor = 'bg-lime-600';     // ✅ Dot color (default green)
  let textColor = 'text-lime-600'; // ✅ Text color (default green)

  if (actionProgress === 0) {
    if (daysToGo > 5) {
      status = 'Ok';
      bgColor = 'bg-lime-600'; textColor = 'text-lime-600';
    } else if (daysToGo > 3) {
      status = 'Watch';
      bgColor = 'bg-orange-400'; textColor = 'text-orange-800';
    } else if (daysToGo >= 2) {
      status = 'At Risk';
      bgColor = 'bg-orange-600'; textColor = 'text-red-600';
    } else if (daysToGo >= 1) {
      status = 'High Risk';
      bgColor = 'bg-red-400'; textColor = 'text-red-600';
    } else {
      status = 'Alert!';
      bgColor = 'bg-red-600'; textColor = 'text-red-600';
    }
  } else if (actionProgress < 75) {
    if (daysToGo > 5) {
      status = 'Ok';
      bgColor = 'bg-lime-600'; textColor = 'text-lime-600';
    } else if (daysToGo >= 2) {
      status = 'Watch';
      bgColor = 'bg-orange-200'; textColor = 'text-orange-800';
    } else if (daysToGo >= 1) {
      status = 'High Risk';
      bgColor = 'bg-red-400'; textColor = 'text-red-600';
    } else {
      status = 'Alert!';
      bgColor = 'bg-red-600'; textColor = 'text-red-600';
    }
  } else if (actionProgress < 90) {
    if (daysToGo > 5) {
      status = 'On Track';
      bgColor = 'bg-lime-600'; textColor = 'text-lime-600';
    } else if (daysToGo >= 2) {
      status = 'Watch';
      bgColor = 'bg-orange-200'; textColor = 'text-orange-800';
    } else if (daysToGo >= 1) {
      status = 'High Risk';
      bgColor = 'bg-red-400'; textColor = 'text-red-600';
    } else {
      status = 'Alert!';
      bgColor = 'bg-red-600'; textColor = 'text-red-600';
    }
  } else if (actionProgress < 95) {
    if (daysToGo > 5) {
      status = 'On Track';
      bgColor = 'bg-lime-600'; textColor = 'text-lime-600';
    } else if (daysToGo >= 1) {
      status = 'Watch';
      bgColor = 'bg-orange-200'; textColor = 'text-orange-800';
    } else {
      status = 'Alert!';
      bgColor = 'bg-red-600'; textColor = 'text-red-600';
    }
  } else if (actionProgress < 100) {
    if (daysToGo > 5) {
      status = 'On Track';
      bgColor = 'bg-lime-600'; textColor = 'text-lime-600';
    } else if (daysToGo >= 1) {
      status = 'Watch';
      bgColor = 'bg-orange-200'; textColor = 'text-orange-800';
    } else {
      status = 'Alert!';
      bgColor = 'bg-red-600'; textColor = 'text-red-600';
    }
  }
  
    return { status, bgColor, textColor };
  };

  const { status, bgColor, textColor } = getTrackingStatus();

  // 4 - Create Markup
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

  return (
    <div className="bg-white rounded m-1 p-2 shadow">
      {/* Header */}
      <div>
        <div className='flex justify-between items-center'>
          <div className='flex items-center justify-start'>
            <div
              onClick={() => setShowNoteDetails(prev => !prev)}
              className="rounded-full h-5 w-5 hover:bg-white flex justify-center items-center cursor-pointer"
            >
              {showNoteDetails ? (
                <MinusIcon className="h-4 w-4 text-orange-600" />
              ) : (
                <PlusIcon className="h-4 w-4 text-orange-600" />
              )}
            </div>
            <p className='text-lg font-bold text-gray-600 ml-2'>{actionIndex + 1}.</p>
            <p className='text-xs text-gray-600 ml-2'>{actionName}</p>
          </div>
          <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
            <PencilSquareIcon
              className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
              onClick={() => {
                setSelectedAction(action)
                setShowUpdateModal(true)
              }}
            />
          </div>
        </div>

        <div className='grid grid-cols-4 gap-4 justify-between items-center border-t pt-2'>
            {/* Progress */}
            <div className='col-span-1 flex justify-center items-center'>
              <div className='h-10 w-10 z-0 relative'>
                <CircularProgressbarWithChildren
                  value={actionProgress}
                  circleRatio={0.75}
                  styles={{
                    path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                    trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                  }}
                >
                  <div><p className='text-xs font-bold text-orange-600'>{actionProgress}%</p></div>
                </CircularProgressbarWithChildren>
              </div>
            </div>

            {/* Last Updated */}
            <div className='col-span-1'>
              <p className="text-[10px] px-2 rounded-full bg-lime-200 inline-block">{getTimeSince(lastUpdated)}</p>
              <p className="text-[9px] italic text-gray-400">last updated</p>
            </div>

            {/* Complete By */}
            <div className='col-span-1 flex flex-col justify-center items-center'>
              <div className='flex items-center justify-center'>
                <CalendarDaysIcon className="h-4 w-4 text-orange-600 mr-1" />
                <p className='text-[10px]'>Complete by:</p>
              </div>
              {/* <p className='text-[9px] bg-white border border-orange-400 rounded-full px-2 inline-block'>
                {moment(completeBy).format("DD MMM YYYY")}
              </p> */}
              <p
                  className={`text-[9px] rounded-full px-2 inline-block border 
                    ${moment(completeBy).isBefore(moment(), 'day')
                      ? 'bg-red-600 text-white border-red-600'
                      : 'bg-white text-gray-600 border-orange-400'}`}
                >
                  {moment(completeBy).format("DD MMM YYYY")}
              </p>
            </div>

            {/* Tracking Status */}
            <div className='col-span-1 flex flex-col justify-end items-center'>
              <div className={`w-6 h-6 rounded-full border ${bgColor}`}>
              </div>
              <p className={`text-[9px] px-2 py-[2px] ${textColor}`}>
                {status}
              </p>
              
            </div>
        </div>

      </div>

      {/* Expanded Details */}
      {showNoteDetails && (
        <div className='mt-2 space-y-2'>
          {actionDesc && (
            <div className='bg-gray-100 rounded p-2 text-xs' dangerouslySetInnerHTML={createMarkup(actionDesc)} />
          )}
          
          {/* Trail Placeholder */}
          {actionNotes?.length > 0 && (
            <div className="border-t mt-2 pt-2">
              <p className="text-xs font-bold text-gray-600">Progress Trail</p>
              {actionNotes
                ?.slice()
                ?.sort((a, b) => new Date(b.actionNoteDate) - new Date(a.actionNoteDate))
                ?.map((note, noteIndex) => {
                  const noteText = note?.actionNoteText || ""
                  const noteDate = note?.actionNoteDate || ""
                  const noteProgress = note?.actionNoteProgress || 0

                  return (
                    <div key={note._id + noteIndex} className='bg-gray-50 rounded my-1 p-2'>
                      <div className='flex items-center'>
                        <div className='h-8 w-8 mr-2'>
                          <CircularProgressbarWithChildren
                            value={noteProgress}
                            circleRatio={0.75}
                            styles={{
                              path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                              trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                            }}
                          >
                            <div><p className='text-[10px] font-bold'>{noteProgress}%</p></div>
                          </CircularProgressbarWithChildren>
                        </div>
                        <div className="flex-1">
                          <p className='text-[11px]'>{noteText}</p>
                          <p className='text-[9px] italic text-gray-400'>{getTimeSince(noteDate)}</p>
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div>
          )}

          {actionNotes?.length === 0 && (
            <p className='text-xs italic text-gray-500'>No progress updates yet.</p>
          )}
        </div>
      )}
      {/* Modal to update the action - 04 Apr 2025 */}
      {showUpdateModal && selectedAction && (
        <EtModalUpdateUserAction
          isOpen={showUpdateModal}
          onClose={() => {
            setShowUpdateModal(false);
            setSelectedAction(null);
          }}
          actionId={selectedAction._id}
          actionData={selectedAction}
          refetchUserActions={refetchUserActions}
        />
      )}
    </div>
  )

}

const User = ({ username, defaultUserPic }) => {
    // const { data: userPic, isFetching: isFetchingUserPic } =
    //   useGetUserPicQuery(username)
    // 20 Mar 2025 - added skip
    const { data: userPic, isFetching: isFetchingUserPic } =
      useGetUserPicQuery(username, { skip: !username })
  
    return (
      <div className="flex justify-center items-center h-12 w-12 rounded-full border border-white bg-gradient-to-r from-orange-600 to-orange-400 shadow-lg shadow-black cursor-pointer">
        {/* Display user picture or loading indicator*/}
        {isFetchingUserPic ? (
          <div>Loading...</div>
        ) : userPic ? (
          <img src={userPic} alt="User" className="h-11 w-11  rounded-full" />
        ) : (
          <img src={defaultUserPic} alt="User" className="h-10 w-10 p-1" />
        )}
      </div>
    )
  }

export default EtTrinityWebLandingAction